/**
 * CallHistoryFilter.tsx
 * Talkroute
 *
 * Created by Vel Genov on 1/22/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import { applyCallHistoryFilter } from "@actions/callHistoryActions";
import { domIds } from "@constants/testConstants";
import uiString from "@constants/uiString";
import { useAppSelector } from "@helpers/hooks/useAppSelector.hook";
import React, { FC } from "react";
import { useDispatch } from "react-redux";
import DropdownComponent from "../PresentationComponents/DropdownComponent";

/**
 * Display the filter dropdown only if there is more than 1 phone number to filter by
 *
 * @param allPhoneNumbers the user's entire phone numbers
 * @param filterBy the phone number we have currently selected to filter by
 */
const CallHistoryFilter: FC = () => {
  const filterBy = useAppSelector(state => state.callHistory.filterBy);
  const callHistory = useAppSelector(state => state.callHistory.data);
  const allPhoneNumbers = useAppSelector(state => state.preferences.allPhoneNumbers);
  const dispatch = useDispatch();

  const showFilterDropdown = () => {
    // Allow the use of a filter if we have at least 1 phone number
    const minimumNumbers = 1;
    let dropdownOptions = [
      {
        value: uiString.ALL_CALLS,
        text: uiString.ALL_CALLS,
      },
    ];
    let disabled = true;

    if (
      Array.isArray(allPhoneNumbers) &&
      allPhoneNumbers.length >= minimumNumbers
    ) {
      disabled = false;
      dropdownOptions = [
        ...dropdownOptions,
        ...allPhoneNumbers.map((entry) => ({
          value: entry.getPhoneNumber(),
          text: entry.getPhoneNumberFormatted(),
        })),
      ];
    }

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div
          style={{
            width: 285,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <DropdownComponent
            id={domIds.CALL_HISTORY_FILTER_DROPDOWN}
            className="text-normal"
            disabled={disabled}
            value={filterBy}
            placeholder={uiString.ALL_CALLS}
            onChange={e => filterDropdownValueChanged(e.target.value)}
            options={dropdownOptions}
            boldColor
            dropdownStyle={{marginLeft: 12, marginTop: 3, letterSpacing: 0.5}}
            smallIcon
          />
        </div>
      </div>
    );
  };

  const filterDropdownValueChanged = (value: unknown) => applyFilter(value);

  /**
   * Apply filter on all call history entries
   *
   * @param filterBy the phone number to filter entried by
   */
  const applyFilter = (filterBy) => {
    dispatch(applyCallHistoryFilter(callHistory, filterBy));
  };

  return showFilterDropdown();
};

export default CallHistoryFilter;